export default __webpack_public_path__ + "static/media/wichtigsten_Infos_Gutscheine.34e69c5f.svg";